import React from 'react';

export default function LoadingSpinner() {
   
    return (
        <div id="loading-spinner">
            <img src="/loading.svg" alt="loading spinner"/>
        </div>
    )
}